import { Markdown } from '~/components/CustomMarkdown';

interface Props {
  markdown: string;
}

export function LegalPage({ markdown }: Props) {
  return (
    <div className="flex flex-col p-4 text-sm">
      <Markdown>{markdown}</Markdown>
    </div>
  );
}
